import { t } from 'ttag';

const data = [
  {
    title: t`Hanging out with Frenkie De Jong.`,
    text: t`See our big selection of Nike Mercurial football boots.`,
    videoText: t`See our big selection of Nike Mercurial football boots.`,
    videoShopnowText: t`Shop now`,
    urls: {
      'da': '/fodboldstoevler/1410-mercurial-kollektion/#/',
      'sv': '/fotbollsskor/1410-mercurial/#/',
      'nb': '/fotballsko/1410-mercurial-kolleksjonen/#/',
      'fi': '/jalkapallokengat/1410-mercurial-mallisto/#/',
      'nl': '/voetbalschoenen/1410-mercurial-collectie/#/',
      'de': '/fussballschuhe/1410-nike-mercurial/#/',
      'fr': '/chaussures-de-football/1410-nike-mercurial/#/',
      'de-AT': '/fussballschuhe/1410-nike-mercurial/#/',
      'en': '/football-boots/1410-mercurial-collection/#/'
    },
    videos: {
      'da': 'https://www.youtube.com/embed/-rSaIKIy_T0',
      'sv': 'https://www.youtube.com/embed/-rSaIKIy_T0',
      'nb': 'https://www.youtube.com/embed/-rSaIKIy_T0',
      'fi': 'https://www.youtube.com/embed/-rSaIKIy_T0',
      'nl': 'https://www.youtube.com/embed/-rSaIKIy_T0',
      'de': 'https://www.youtube.com/embed/-rSaIKIy_T0',
      'fr': 'https://www.youtube.com/embed/-rSaIKIy_T0',
      'de-AT': 'https://www.youtube.com/embed/-rSaIKIy_T0',
      'en': 'https://www.youtube.com/embed/-rSaIKIy_T0'
    },
    image: [
      'https://static.uniid.it/Bq_p1AFU5_8T6x-9Z7kBkEaknpX',
      'https://static.uniid.it/IgjlsobM4bjdne_ajtBOAdT8GK9',
      'https://static.uniid.it/MUpP2U4l6XrTpwnfomq2hzLsOEZ'
    ]
  },
  {
    title: t`Unisport talks about success with CR7`,
    text: t`Click here to see what happens when we present him with the new Nike Mercurial Superfly.`,
    videoText: t`See our big selection of Nike Mercurial Superfly football boots.`,
    videoShopnowText: t`Shop now`,
    urls: {
      'da': '/fodboldstoevler/7375-nike-mercurial-superfly/',
      'sv': '/fotbollsskor/7375-nike-mercurial-superfly/',
      'nb': '/fotballsko/7375-nike-mercurial-superfly/',
      'fi': '/jalkapallokengat/7375-nike-mercurial-superfly/',
      'nl': '/voetbalschoenen/7375-nike-mercurial-superfly/',
      'de': '/fussballschuhe/7375-nike-mercurial-superfly/',
      'fr': '/chaussures-de-football/7375-nike-mercurial-superfly/',
      'de-AT': '/fussballschuhe/7375-nike-mercurial-superfly/',
      'en': '/football-boots/7375-nike-mercurial-superfly/'
    },
    videos: {
      'da': 'https://www.youtube.com/embed/1KJFsm8NDyE',
      'sv': 'https://www.youtube.com/embed/1KJFsm8NDyE',
      'nb': 'https://www.youtube.com/embed/1KJFsm8NDyE',
      'fi': 'https://www.youtube.com/embed/1KJFsm8NDyE',
      'nl': 'https://www.youtube.com/embed/1KJFsm8NDyE',
      'de': 'https://www.youtube.com/embed/1KJFsm8NDyE',
      'fr': 'https://www.youtube.com/embed/1KJFsm8NDyE',
      'de-AT': 'https://www.youtube.com/embed/1KJFsm8NDyE',
      'en': 'https://www.youtube.com/embed/1KJFsm8NDyE'
    },
    image: [
      'https://static-paths.uniid.it/football-star/2022-02-24/superstar-banner-desktop-cr7.jpg',
      'https://static-paths.uniid.it/football-star/2022-02-24/superstar-banner-tablet-cr7.jpg',
      'https://static-paths.uniid.it/football-star/2022-02-24/superstar-banner-mobile-cr7.jpg'
    ]
  },
  {
    title: t`Unisport connects with Mbappé.`,
    text: t`See what happened when Mbappé got the full #unisportlife experience.`,
    videoText: t`See our big selection of Nike Mercurial Superfly football boots.`,
    videoShopnowText: t`Shop now`,
    urls: {
      'da': '/fodboldstoevler/7375-nike-mercurial-superfly/',
      'sv': '/fotbollsskor/7375-nike-mercurial-superfly/',
      'nb': '/fotballsko/7375-nike-mercurial-superfly/',
      'fi': '/jalkapallokengat/7375-nike-mercurial-superfly/',
      'nl': '/voetbalschoenen/7375-nike-mercurial-superfly/',
      'de': '/fussballschuhe/7375-nike-mercurial-superfly/',
      'fr': '/chaussures-de-football/7375-nike-mercurial-superfly/',
      'de-AT': '/fussballschuhe/7375-nike-mercurial-superfly/',
      'en': '/football-boots/7375-nike-mercurial-superfly/'
    },
    videos: {
      'da': 'https://www.youtube.com/embed/0VZW8UeuLmU?',
      'sv': 'https://www.youtube.com/embed/0VZW8UeuLmU?',
      'nb': 'https://www.youtube.com/embed/0VZW8UeuLmU?',
      'fi': 'https://www.youtube.com/embed/0VZW8UeuLmU?',
      'nl': 'https://www.youtube.com/embed/0VZW8UeuLmU?',
      'de': 'https://www.youtube.com/embed/0VZW8UeuLmU?',
      'fr': 'https://www.youtube.com/embed/0VZW8UeuLmU?',
      'de-AT': 'https://www.youtube.com/embed/0VZW8UeuLmU?',
      'en': 'https://www.youtube.com/embed/0VZW8UeuLmU?'
    },
    image: [
      'https://static-paths.uniid.it/football-star/2017-10-04/mbappe_banner_desktop_index.jpg',
      'https://static-paths.uniid.it/football-star/2017-10-04/mbappe_banner_tablet_index.jpg',
      'https://static-paths.uniid.it/football-star/2017-10-04/mbappe_banner_mobile_index.jpg'
    ]
  },
  {
    title: t`Unisport sits down with Messi`,
    text: t`Watch how Messi reflects on his career and his most iconic moments.`,
    videoShopnowText: t`Shop now`,
    videoText: t`See our big selection of adidas X Speedportal football boots.`,
    urls: {
      'da': '/adidas-x-speedportal/?to=40&sort=latest-online&search_query=speedflow&page=1',
      'sv': '/adidas-x-speedportal/?to=40&sort=latest-online&search_query=speedflow&page=1',
      'nb': '/adidas-x-speedportal/?to=40&sort=latest-online&search_query=speedflow&page=1',
      'fi': '/adidas-x-speedportal/?to=40&sort=latest-online&search_query=speedflow&page=1',
      'nl': '/adidas-x-speedportal/?to=40&sort=latest-online&search_query=speedflow&page=1',
      'de': '/adidas-x-speedportal/?to=40&sort=latest-online&search_query=speedflow&page=1',
      'fr': '/adidas-x-speedportal/?to=40&sort=latest-online&search_query=speedflow&page=1',
      'de-AT':
        '/adidas-x-speedportal/?to=40&sort=latest-online&search_query=speedflow&page=1',
      'en': '/adidas-x-speedportal/?to=40&sort=latest-online&search_query=speedflow&page=1'
    },
    videos: {
      'da': 'https://www.youtube.com/embed/FktnMutgijc',
      'sv': 'https://www.youtube.com/embed/FktnMutgijc',
      'nb': 'https://www.youtube.com/embed/FktnMutgijc',
      'fi': 'https://www.youtube.com/embed/FktnMutgijc',
      'nl': 'https://www.youtube.com/embed/FktnMutgijc',
      'de': 'https://www.youtube.com/embed/FktnMutgijc',
      'fr': 'https://www.youtube.com/embed/FktnMutgijc',
      'de-AT': 'https://www.youtube.com/embed/FktnMutgijc',
      'en': 'https://www.youtube.com/embed/FktnMutgijc'
    },
    image: [
      'https://static-paths.uniid.it/football-star/2017-10-04/messi_banner_desktop_index.jpg',
      'https://static-paths.uniid.it/football-star/2017-10-04/messi_banner_tablet_index.jpg',
      'https://static-paths.uniid.it/football-star/2017-10-04/messi_banner_mobile_index.jpg'
    ]
  },
  {
    title: t`Unisport meets Van Dijk`,
    text: '',
    videoShopnowText: t`Shop now`,
    videoText: t`See our big selection of Nike Tiempo football boots`,
    urls: {
      'da': '/fodboldstoevler/1411-tiempo-kollektion/',
      'sv': '/fotbollsskor/1411-tiempo/',
      'nb': '/fotballsko/1411-tiempo-kolleksjonen/',
      'fi': '/jalkapallokengat/1411-tiempo-mallisto/',
      'nl': '/voetbalschoenen/1411-tiempo/',
      'de': '/fussballschuhe/1411-nike-tiempo/',
      'fr': '/chaussures-de-football/1411-nike-tiempo/',
      'de-AT': '/fussballschuhe/1411-nike-tiempo/',
      'en': '/football-boots/1411-tiempo-collection/'
    },
    videos: {
      'da': 'https://www.youtube.com/embed/UU3CMcT3mBI',
      'sv': 'https://www.youtube.com/embed/UU3CMcT3mBI',
      'nb': 'https://www.youtube.com/embed/UU3CMcT3mBI',
      'fi': 'https://www.youtube.com/embed/UU3CMcT3mBI',
      'nl': 'https://www.youtube.com/embed/UU3CMcT3mBI',
      'de': 'https://www.youtube.com/embed/UU3CMcT3mBI',
      'fr': 'https://www.youtube.com/embed/UU3CMcT3mBI',
      'de-AT': 'https://www.youtube.com/embed/UU3CMcT3mBI',
      'en': 'https://www.youtube.com/embed/UU3CMcT3mBI'
    },
    image: [
      'https://static-paths.uniid.it/football-star/2022-02-24/superstar-banner-desktop-vvd.jpg',
      'https://static-paths.uniid.it/football-star/2022-02-24/superstar-banner-tablet-vvd.jpg',
      'https://static-paths.uniid.it/football-star/2022-02-24/superstar-banner-mobile-vvd.jpg'
    ]
  },

  // not DE or AT
  {
    title: t`Unisport gets goalkeeper tips from Thibaut Courtois`,
    text: '',
    videoShopnowText: t`Shop now`,
    videoText: t`See our big assortment of Nike goalkeeper gloves.`,
    urls: {
      'da': '/maalmandshandsker/594-nike-malmandshandsker/#/',
      'sv': '/malvaktshandskar/594-nike-malvaktshandskar/#/',
      'nb': '/fotballutstyr/594-nike-keeperhansker/#/',
      'fi': '/sekalaiset-tarvikkeet/594-nike-maalivahdin-hanskat/#/',
      'nl': '/voetbalaccessoires/594-nike-keepershandschoenen/#/',
      'de': '',
      'fr': '/gants-et-equipements-de-gardien/594-gants-de-gardien-nike/#/',
      'de-AT': '',
      'en': '/keepergloves/594-nike-goalkeeper-gloves/#/'
    },
    videos: {
      'da': 'https://www.youtube.com/embed/-JMHhCf_gKY',
      'sv': 'https://www.youtube.com/embed/-JMHhCf_gKY',
      'nb': 'https://www.youtube.com/embed/-JMHhCf_gKY',
      'fi': 'https://www.youtube.com/embed/-JMHhCf_gKY',
      'nl': 'https://www.youtube.com/embed/-JMHhCf_gKY',
      'de': '',
      'fr': 'https://www.youtube.com/embed/-JMHhCf_gKY',
      'de-AT': '',
      'en': 'https://www.youtube.com/embed/-JMHhCf_gKY'
    },
    image: [
      'https://static-paths.uniid.it/football-star/2022-02-24/superstar-banner-desktop-courtois.jpg',
      'https://static-paths.uniid.it/football-star/2022-02-24/superstar-banner-tablet-courtois.jpg',
      'https://static-paths.uniid.it/football-star/2022-02-24/superstar-banner-mobile-courtois.jpg'
    ]
  },

  // only DE and AT
  {
    title: 'Unisport gets goalkeeper tips from Manuel Neuer',
    text: '',
    videoShopnowText: t`Shop now`,
    videoText: 'See our big assortment of adidas goalkeeper gloves.',
    urls: {
      'da': '',
      'sv': '',
      'nb': '',
      'fi': '',
      'nl': '',
      'de': '/fussballschuhe/1415-predator-collection/',
      'fr': '',
      'de-AT': '/fussballschuhe/1415-predator-collection/',
      'en': ''
    },
    videos: {
      'da': '',
      'sv': '',
      'nb': '',
      'fi': '',
      'nl': '',
      'de': 'https://www.youtube.com/embed/1-m1X808FOI',
      'fr': '',
      'de-AT': 'https://www.youtube.com/embed/1-m1X808FOI',
      'en': ''
    },
    image: [
      'https://static-paths.uniid.it/football-star/2017-10-04/neurer_banner_desktop_index.jpg',
      'https://static-paths.uniid.it/football-star/2017-10-04/neurer_banner_tablet_index.jpg',
      'https://static-paths.uniid.it/football-star/2017-10-04/neurer_banner_mobile_index.jpg'
    ]
  },

  // French Only
  {
    title: 'Unisport reçoit les conseils de Benjamin Pavard',
    text: '',
    videoShopnowText: t`Shop now`,
    videoText:
      'Découvrez notre large sélection de produits pour gardien de but',
    urls: {
      'da': '',
      'sv': '',
      'nb': '',
      'fi': '',
      'nl': '',
      'de': '',
      'fr': '/gardien-de-but/#/',
      'de-AT': '',
      'en': ''
    },
    videos: {
      'da': '',
      'sv': '',
      'nb': '',
      'fi': '',
      'nl': '',
      'de': '',
      'fr': 'https://www.youtube.com/embed/0tR6bvZoDqM',
      'de-AT': '',
      'en': ''
    },
    image: [
      'https://static-paths.uniid.it/football-star/2022-02-24/superstar-banner-desktop-pavard.jpg',
      'https://static-paths.uniid.it/football-star/2022-02-24/superstar-banner-tablet-pavard.jpg',
      'https://static-paths.uniid.it/football-star/2022-02-24/superstar-banner-mobile-pavard.jpg'
    ]
  },
  {
    title: 'Verratti dévoile ses secrets à Unisport',
    text: '',
    videoShopnowText: t`Shop now`,
    videoText: 'Découvre notre grande sélection de chaussures Nike Phantom GT',
    urls: {
      'da': '',
      'sv': '',
      'nb': '',
      'fi': '',
      'nl': '',
      'de': '',
      'fr': '/nike-phantom-gt/#/',
      'de-AT': '',
      'en': ''
    },
    videos: {
      'da': '',
      'sv': '',
      'nb': '',
      'fi': '',
      'nl': '',
      'de': '',
      'fr': 'https://www.youtube.com/embed/92c4r4VGIrA',
      'de-AT': '',
      'en': ''
    },
    image: [
      'https://static-paths.uniid.it/football-star/2022-02-24/superstar-banner-desktop-veratti.jpg',
      'https://static-paths.uniid.it/football-star/2022-02-24/superstar-banner-tablet-veratti.jpg',
      'https://static-paths.uniid.it/football-star/2022-02-24/superstar-banner-mobile-veratti.jpg'
    ]
  },
  {
    title: 'Marquinhos donne à Unisport les secrets pour être défenseur pro',
    text: '',
    videoShopnowText: t`Shop now`,
    videoText: 'Découvre notre grande sélection de chaussures Nike Phantom GT',
    urls: {
      'da': '',
      'sv': '',
      'nb': '',
      'fi': '',
      'nl': '',
      'de': '',
      'fr': '/nike-phantom-gt/#/',
      'de-AT': '',
      'en': ''
    },
    videos: {
      'da': '',
      'sv': '',
      'nb': '',
      'fi': '',
      'nl': '',
      'de': '',
      'fr': 'https://www.youtube.com/embed/vJL1X3uaq2s?controls=0',
      'de-AT': '',
      'en': ''
    },
    image: [
      'https://static-paths.uniid.it/football-star/2022-02-24/superstar-banner-desktop-marquinhos.jpg',
      'https://static-paths.uniid.it/football-star/2022-02-24/superstar-banner-tablet-marquinhos.jpg',
      'https://static-paths.uniid.it/football-star/2022-02-24/superstar-banner-mobile-marquinhos.jpg'
    ]
  },
  {
    title: 'Unisport challenge Presnel Kimpembe',
    text: '',
    videoShopnowText: t`Shop now`,
    videoText: 'Découvre notre immense sélection de crampons Nike',
    urls: {
      'da': '',
      'sv': '',
      'nb': '',
      'fi': '',
      'nl': '',
      'de': '',
      'fr': '/chaussures-de-football/1409-chaussures-de-football-nike/',
      'de-AT': '',
      'en': ''
    },
    videos: {
      'da': '',
      'sv': '',
      'nb': '',
      'fi': '',
      'nl': '',
      'de': '',
      'fr': 'https://www.youtube.com/embed/N7DPdFIaF_I',
      'de-AT': '',
      'en': ''
    },
    image: [
      'https://static-paths.uniid.it/football-star/2022-02-24/superstar-banner-desktop-kimpembe.jpg',
      'https://static-paths.uniid.it/football-star/2022-02-24/superstar-banner-tablet-kimpembe.jpg',
      'https://static-paths.uniid.it/football-star/2022-02-24/superstar-banner-mobile-kimpembe.jpg'
    ]
  },
  // DK only
  {
    title: 'Unisport får gode råd fra Eriksen',
    text: '',
    videoShopnowText: t`Shop now`,
    videoText: 'Se vores store udvalg af Nike Mercurial fodboldstøvler.',
    urls: {
      'da': '',
      'sv': '',
      'nb': '',
      'fi': '',
      'nl': '',
      'de': '',
      'fr': '/chaussures-de-football/1409-chaussures-de-football-nike/',
      'de-AT': '',
      'en': ''
    },
    videos: {
      'da': 'https://www.youtube.com/embed/IkB8nCGVy8g',
      'sv': '',
      'nb': '',
      'fi': '',
      'nl': '',
      'de': '',
      'fr': '',
      'de-AT': '',
      'en': ''
    },
    image: [
      'https://static-paths.uniid.it/football-star/2022-02-24/superstar-banner-desktop-eriksen.jpg',
      'https://static-paths.uniid.it/football-star/2022-02-24/superstar-banner-tablet-eriksen.jpg',
      'https://static-paths.uniid.it/football-star/2022-02-24/superstar-banner-mobile-eriksen.jpg'
    ]
  },
  {
    title: 'Midtbane tips fra Pierre Emile',
    text: '',
    videoShopnowText: t`Shop now`,
    videoText: 'Se vores store udvalg af adidas Predator fodboldstøvler.',
    urls: {
      'da': '/fodboldstoevler/1415-predator-kollektion/#/',
      'sv': '',
      'nb': '',
      'fi': '',
      'nl': '',
      'de': '',
      'fr': '',
      'de-AT': '',
      'en': ''
    },
    videos: {
      'da': 'https://www.youtube.com/embed/k2HApTobThw',
      'sv': '',
      'nb': '',
      'fi': '',
      'nl': '',
      'de': '',
      'fr': '',
      'de-AT': '',
      'en': ''
    },
    image: [
      'https://static-paths.uniid.it/football-star/2022-02-24/superstar-banner-desktop-pierre.jpg',
      'https://static-paths.uniid.it/football-star/2022-02-24/superstar-banner-tablet-pierre.jpg',
      'https://static-paths.uniid.it/football-star/2022-02-24/superstar-banner-mobile-pierre.jpg'
    ]
  }
];

export default data;
